module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"selected":"選択中","switch-account":"アカウントを切り替え"},"en":{"selected":"SECTED","switch-account":"Switch Account"}}')
  delete Component.options._Ctor
}
